import { cn } from "@/lib/utils";

/**
 * Skeleton placeholder — pulsating block used to mimic content shape
 * while data loads. Use semantic tokens only (bg-muted) so it adapts
 * to dark/light themes.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted/60", className)}
      {...props}
    />
  );
}

export { Skeleton };
